import { Image } from "./image";
import React from "react";
import { SectionHeader } from "./SectionHeader";

export const Gallery = ({ data, section }) => {
  const s = section || {};
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <SectionHeader heading={s.heading} subheading={s.subheading} />
        <div className="row">
          <div className="portfolio-items">
            {data
              ? data.map((d, i) => (
                  <div key={`${d.title}-${i}`} className="col-sm-6 col-md-4 col-lg-4">
                    <Image title={d.title} largeImage={d.largeImage} smallImage={d.smallImage} />
                  </div>
                ))
              : null}
          </div>
        </div>
      </div>
    </div>
  );
};
